import { Activity, Award, Heart, User } from "lucide-react";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router";

const ServiceSymptoms = ({ symptoms, serviceName }) => {
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);
    const sectionRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (sectionRef.current) {
            observer.observe(sectionRef.current);
        }

        return () => {
            if (sectionRef.current) {
                observer.unobserve(sectionRef.current);
            }
        };
    }, []);

    // Clean symptoms by removing check marks
    const cleanSymptoms = symptoms.map(symptom => symptom.replace(/^✔ /, ''));

    // Keep varied icon colors but update to match the logo theme
    const icons = [
        <Activity className="h-10 w-10 text-teal-500" />,
        <User className="h-10 w-10 text-lime-500" />,
        <Heart className="h-10 w-10 text-teal-400" />,
        <Award className="h-10 w-10 text-lime-600" />
    ];

    return (
        <section
            ref={sectionRef}
            className={`py-16 bg-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
        >
            <div className="px-4 md:px-20">
                <h2 className="text-3xl font-bold mb-2 text-teal-600">Who Needs This Treatment?</h2>
                <div className="w-24 h-1 bg-lime-500 mb-12 mt-2"></div>

                <div className="bg-gradient-to-br from-teal-50 to-lime-50 rounded-xl p-6 md:p-8">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {cleanSymptoms.map((symptom, index) => (
                            <div
                                key={index}
                                className={`flex items-center bg-white p-6 rounded-lg shadow-md transform transition-all duration-500 hover:shadow-lg hover:-translate-y-1 ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-10'}`}
                                style={{ transitionDelay: `${index * 150}ms` }}
                            >
                                <div className="mr-5 flex-shrink-0">
                                    {icons[index % icons.length]}
                                </div>
                                <p className="text-lg text-gray-700">{symptom}</p>
                            </div>
                        ))}
                    </div>

                    <div className="mt-12 text-center">
                        <p className="text-xl font-medium text-gray-700 mb-6">Not sure if {serviceName} is right for your dental condition?</p>
                        <button onClick={() => navigate('/schedule-appointment')}
                            className="cursor-pointer bg-teal-500 text-white font-medium py-3 px-8 rounded-full shadow-md transition-all duration-300 hover:bg-lime-500 hover:shadow-lg transform hover:-translate-y-1">
                            Schedule a Consultation
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default ServiceSymptoms;